import { Injectable, inject } from '@angular/core';
import { GoogleTrackingService } from '../google-tracking.service';

@Injectable({
    providedIn: 'root',
})
export class UserTrackingService {
    private readonly _googleTrackingService = inject(GoogleTrackingService);

    public trackSuccessfullLogin(): void {
        this._googleTrackingService.track({
            event: 'login',
            login: 'erfolgreich',
        });
    }

    public trackUserDetails(userId: string, country: string): void {
        this._googleTrackingService.trackWithoutEvent({
            userID: userId,
            country,
        });
    }
}
